// extracted by mini-css-extract-plugin
module.exports = {"carousel-items":"image-carousel_carousel-items__5eYQo","slideImages":"image-carousel_slideImages___H6T9"};